<script setup>
import { ref, shallowRef, onMounted } from "vue"

const props = defineProps({
  tabs: {
    type: Array,
    required: true,
    // Struktur: [{ name: "...", title: "...", component: ..., endpoint: "..." }]
  },
  preSelected: {
    type: String,
    default: null
  }
})

const activeSubTab = ref(null)
const subTabData = ref({})
const subTabComponent = shallowRef(null)
const loading = ref(false)
const error = ref(null)

async function selectSubTab(index) {
  const tab = props.tabs[index]
  activeSubTab.value = index
  subTabComponent.value = null
  error.value = null

  loading.value = true
  try {
    const response = await fetch(tab.endpoint)
    if (!response.ok) throw new Error("Fehler: " + response.status)
    const json = await response.json()

    subTabData.value[index] = json
    subTabComponent.value = tab.component
  } catch (err) {
    error.value = err.message
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  if (props.preSelected) {
    const idx = props.tabs.findIndex(t => t.name === props.preSelected)
    if (idx !== -1) {
      selectSubTab(idx)
    }
  }
})
</script>

<template>
  <div class="subtabs">
    <!-- SubTab Header -->
    <div class="subtab-header">
      <button
          v-for="(tab, index) in tabs"
          :key="index"
          :class="['subtab-button', { active: activeSubTab === index }]"
          @click="selectSubTab(index)"
      >
        {{ tab.title }}
      </button>
    </div>

    <!-- SubTab Content -->
    <div class="subtab-content" id="subtab-content">
      <div v-if="loading">⏳ Lädt...</div>
      <div v-else-if="error">❌ {{ error }}</div>
      <component
          v-else-if="subTabComponent"
          :is="subTabComponent"
          :data="subTabData[activeSubTab]"
          :deep_jump_id="tabs[activeSubTab].deep_jump_id"
      />
    </div>
  </div>
</template>

<style scoped>
.subtabs {
  display: flex;           /* nebeneinander */
  align-items: flex-start; /* Header links, Content rechts */
  gap: 1rem;
}

/* SubTabs links in einer Spalte */
.subtab-header {
  display: flex;
  flex-direction: column;  /* vertikal */
  min-width: 250px;
  border-right: 1px solid #ddd;
}

.subtab-button {
  padding: 1rem 1rem;
  border: none;
  background: #ffffff;
  cursor: pointer;
  text-align: left;
  font-size: 1rem;
  color: #b6b6b6;
  font-weight: bold;
}

.subtab-button:hover {
  background-color: #1D4899;
  color: #FFCB04;
}

.subtab-button.active {
  color: #0073aa;

}

.subtab-content {
  flex: 1;        /* nimmt restliche Breite */
  padding: 1rem;
}
</style>
